















import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../../lib/ajax'
import AbpBase from '../../../../../../lib/abpbase'
@Component({
    name:'yearCount',
    filters:{
        
    }
})
export default class YearCount extends AbpBase {
    // 初始化数据
    initData: any = {
        searchData:{},
        tableData:{
            loading: true,
            title:[
               {
                    title: '序号',
                    key: 'serialNumber',
                    align: 'center',
                    width: 60,
                    render: (h:any, params:any) => {
                        if (params.row._index+1 == this.initData.tableData.content.length) {
                            return h('div','总计');
                        } else {
                            return h('div',params.row._index+1);
                        }
                    }
                },
                {
                    title: '项目名称',
                    key: 'projectName',
                    align: 'center',
                },
                {
                    title: '收款',
                    key: 'inAmountFormat',
                    align: 'center',
                },
                {
                    title: '成本',
                    key: 'costAmountFormat',
                    align: 'center',
                },
                {
                    title: '项目管理费',
                    key: 'projectMAmountFormat',
                    align: 'center',
                },
                {
                    title: '所管理费',
                    key: 'depMAmountFormat',
                    align: 'center',
                },
                {
                    title: '项目结余',
                    key: 'profitAmountFormat',
                    align: 'center',
                },
                {
                    title: '外协',
                    key: 'outCoordAmountFormat',
                    align: 'center',
                },
                {
                    title: '其他',
                    key: 'otherAmount',
                    align: 'center',
                },
            ],
            content:[]
        },
    }
    mounted(){
        this.initData.searchData.beginDt = new Date(new Date().getFullYear()+'-01-01');
        this.GetData();
    }
    GetData() {
        Ajax.post('/api/services/app/OneFinanceManager/StatisticYearAsync', this.initData.searchData)
            .then( (res: any) => {
                console.log(res);
                if(res){
                    this.initData.tableData.content = res.data.result.items;
                    this.initData.tableData.loading = false;
                }
            } )
    }
}
